<template>
    <div class="share_box" ref="share_dom">
        <img
            src="@/assets/img/game/bg_share_0.jpg"
            alt=""
            class="sourceimg bg0"
        />
        <img :src="catchpic" alt="" class="catchsource" />
        <img src="@/assets/img/game/bg_share_2.png" alt="" class="sourceimg" />
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import html2canvas from 'html2canvas';
import { Bus } from '@/utils/eventBus.js';
export default {
    name: 'sharePicView',
    props: {
        // 游戏截屏bs64
        catchpic: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        }
    },
    methods: {
        ...mapMutations(['SET_STATE', 'SHOW_POPUP', 'SET_LANG']),
        ...mapActions(['uploadImg']),
        eventBusDemo() {
            Bus.$emit('_eventBusDemo');
        },
        // 生成分享图
        createSharePic() {
            let _this = this;
            let $dom = this.$refs.share_dom;
            html2canvas($dom).then(function(canvas) {
                // console.log(canvas.toDataURL('image/jpeg'));
                _this.SET_STATE({
                    key: 'createingSharePic',
                    val: false
                });
                _this.SET_STATE({
                    key: 'waiting',
                    val: false
                });
                let bs64 = canvas.toDataURL('image/jpeg');
                // 转完后记录到store
                _this.SET_STATE({
                    key: 'gamePic',
                    val: bs64
                });
            });
            return;
        }
    },
    mounted() {
        // 生成分享图
        Bus.$on('_createSharePic', () => {
            this.createSharePic();
        });
    }
};
</script>

<style lang="less" scoped>
.share_box {
    position: absolute;
    width: 750px;
    height: 1380px;
    top: 0;
    left: 100%;

    .sourceimg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        &.bg0 {
            width: 101%;
            height: 101%;
        }
    }

    .catchsource {
        position: absolute;
        width: 596px;
        height: 807px;
        top: 286px;
        left: 77px;
    }
}
</style>
